export const totalRedeemedDollars = (state) => state.totalRedeemedDollars

export const customer = (state) => state.customer || {}

export const coupons = (state) => state.coupons
